import { create } from 'zustand'
import { initialMaterialTypePageState, MaterialTypeItemData, MaterialTypeListStateType } from '../core/_model';
import { ActionsKey } from '../../../../common/models/Actions';

export type ActionedMaterialType = {data: MaterialTypeItemData, action: ActionsKey}

type MaterialTypeData = {
  materialTypeList: any;
  setMaterialTypeList: (access: any) => void;
  actioned: ActionedMaterialType | null;
  setActioned: (act: ActionedMaterialType | null) => void;
}

export const useMaterialTypeStore = create<MaterialTypeData>((set) => ({
  materialTypeList: null,
  setMaterialTypeList: (mtl) => set((state) => ({materialTypeList: mtl})),
  actioned: null,
  setActioned: (act) => set((state) => ({actioned: act})),
}))

export const useMaterialTypeListState = create<MaterialTypeListStateType>((set) => ({
  pageState: initialMaterialTypePageState,
  setPageState: (pageState) => set((state) => ({pageState})),
}))
